import _asyncToGenerator from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import _regeneratorRuntime from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/regenerator";
import "core-js/modules/es6.regexp.replace.js";

/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.conf.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/
import 'quasar/dist/quasar.ie.polyfills.js';
import '@quasar/extras/roboto-font/roboto-font.css';
import '@quasar/extras/material-icons/material-icons.css';
import '@quasar/extras/mdi-v5/mdi-v5.css';
import '@quasar/extras/material-icons-outlined/material-icons-outlined.css'; // We load Quasar stylesheet file

import 'quasar/dist/quasar.sass';
import 'src/css/app.scss';
import 'src/css/../assets/style.css';
import 'src/css/../assets/styles/main.scss';
import Vue from 'vue';
import createApp from "./app.js";
import qboot_Bootapi from 'boot/api';
import qboot_Bootautomation from 'boot/automation';
import qboot_Bootcomponents from 'boot/components';
import qboot_Bootdirectives from 'boot/directives';
import qboot_Bootfilters from 'boot/filters';
import qboot_Bootformatters from 'boot/formatters';
import qboot_Booti18n from 'boot/i18n';
import qboot_Bootlogger from 'boot/logger';
import qboot_Bootmask from 'boot/mask';
import qboot_Bootutils from 'boot/utils';
import qboot_Bootrecaptcha from 'boot/recaptcha';
import qboot_Bootvuelidate from 'boot/vuelidate';
import qboot_Bootgoogleanalytics from 'boot/google-analytics';
import qboot_Bootsentry from 'boot/sentry';

function start() {
  return _start.apply(this, arguments);
}

function _start() {
  _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _yield$createApp, app, store, router, routeUnchanged, redirect, urlPath, bootFiles, i;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return createApp();

          case 2:
            _yield$createApp = _context.sent;
            app = _yield$createApp.app;
            store = _yield$createApp.store;
            router = _yield$createApp.router;
            routeUnchanged = true;

            redirect = function redirect(url) {
              routeUnchanged = false;
              window.location.href = url;
            };

            urlPath = window.location.href.replace(window.location.origin, '');
            bootFiles = [qboot_Bootapi, qboot_Bootautomation, qboot_Bootcomponents, qboot_Bootdirectives, qboot_Bootfilters, qboot_Bootformatters, qboot_Booti18n, qboot_Bootlogger, qboot_Bootmask, qboot_Bootutils, qboot_Bootrecaptcha, qboot_Bootvuelidate, qboot_Bootgoogleanalytics, qboot_Bootsentry];
            i = 0;

          case 11:
            if (!(routeUnchanged === true && i < bootFiles.length)) {
              _context.next = 29;
              break;
            }

            if (!(typeof bootFiles[i] !== 'function')) {
              _context.next = 14;
              break;
            }

            return _context.abrupt("continue", 26);

          case 14:
            _context.prev = 14;
            _context.next = 17;
            return bootFiles[i]({
              app: app,
              router: router,
              store: store,
              Vue: Vue,
              ssrContext: null,
              redirect: redirect,
              urlPath: urlPath
            });

          case 17:
            _context.next = 26;
            break;

          case 19:
            _context.prev = 19;
            _context.t0 = _context["catch"](14);

            if (!(_context.t0 && _context.t0.url)) {
              _context.next = 24;
              break;
            }

            window.location.href = _context.t0.url;
            return _context.abrupt("return");

          case 24:
            console.error('[Quasar] boot error:', _context.t0);
            return _context.abrupt("return");

          case 26:
            i++;
            _context.next = 11;
            break;

          case 29:
            if (!(routeUnchanged === false)) {
              _context.next = 31;
              break;
            }

            return _context.abrupt("return");

          case 31:
            new Vue(app);

          case 32:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[14, 19]]);
  }));
  return _start.apply(this, arguments);
}

start();